import {useRuntimeConfig} from "#app";

export const isProduction = () => {
	return useRuntimeConfig().public["appEnv"] === 'production';
};
